import React from "react";
const RoomConfigurationHead = React.memo(({ renderPageTypeBtn, headChild }) => {
    return (React.createElement("div", { className: "r_header" },
        React.createElement("div", { className: "r_left" }, renderPageTypeBtn),
        React.createElement("div", { className: "r_right" }, headChild)));
});
export default RoomConfigurationHead;
